import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
// import mixin
import { mainMixins } from "@/mixins/dpMixin.js";
import "@/components/validation/vee-validate.js";
Vue.mixin(mainMixins);
Vue.config.productionTip = false;

import { returnURL } from "@/api/login";
import "./registerServiceWorker";
Vue.prototype.$url = returnURL();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
